/** A public nickname, not a unique handle or a provider's personal name. */
export function writerName(value: unknown): string | null {
  if (typeof value !== 'string') return null;
  const name = value.normalize('NFKC').trim();
  return name.length > 0 && name.length <= 32 && !/[\p{C}<>]/u.test(name) ? name : null;
}
